import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root(t) {
    var width = parseInt(t.calendarCellSize) * 7;
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      box-sizing: content-box;\n      color: ", ";\n      display: block;\n      padding: 0 ", ";\n      width: ", "px;\n      overflow: hidden;\n      touch-action: none;\n    "])), t.textColorDefault, t.calendarPaddingX, width);
  },
  wrapper: function wrapper() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      position: relative;\n    "])));
  }
});